// extracted by mini-css-extract-plugin
export default {"button":"link_button_button__88LFs"};